export default __webpack_public_path__ + "static/media/bg_liq_lines.7fb28f15.svg";